import { z } from 'zod';
import { get } from 'radashi';
import fi from './locales/fi.json' with { type: 'json' };
import sv from './locales/sv.json' with { type: 'json' };
import de from './locales/de.json' with { type: 'json' };
import pl from './locales/pl.json' with { type: 'json' };
import enGB from './locales/en-GB.json' with { type: 'json' };
import { supportedLocales } from './constants.js';
export const t = (key, locale) => {
    const localeData = {
        'en-GB': enGB,
        fi,
        sv,
        de,
        pl,
    }[locale];
    const value = get(localeData, key);
    return typeof value === 'string' ? value : key;
};
export const setDefaultError = (locale) => {
    z.config({
        customError: ({ code }) => ['too_small', 'invalid_type'].includes(code)
            ? t('fillField', locale)
            : t('fillFieldCorrectly', locale),
    });
};
export const isSupportedLocale = (locale) => supportedLocales.includes(locale);
